import { useState } from "react";
import {
  GoabContainer,
  GoabBlock,
  GoabFormItem,
  GoabRadioGroup,
  GoabRadioItem,
  GoabCheckbox,
  GoabInput,
  GoabSpacer,
} from "@abgov/react-components";

import { useGenerationForm, useSessionManagement } from "../../hooks";

import { formatPhoneNumber } from "../../../../../MPP-Common-SPA/utils/globalUtility";

export const TemporaryContactInformationSection = () => {
  const {
    form,
    fieldValues,
    fieldErrors,
    fieldTouches,
    handleChange,
    handleBlur,
    isReady,
  } = useGenerationForm("TemporaryContactInformation");

  const { getResourceValue } = useSessionManagement();
  const [inputKey, setInputKey] = useState(0);

  // Early return if form isn't ready
  if (!isReady) return <></>;

  const personalNumberError =
    fieldErrors.personalNumber && fieldTouches.personalNumber;
  const tempPhoneNumberError =
    fieldErrors.tempPhoneNumber && fieldTouches.tempPhoneNumber;

  return (
    <>
      <GoabContainer accent="thin">
        <h3>
          {getResourceValue({ key: "RESOURCES@tempContactInfo.form.title" })}
        </h3>
        <GoabBlock direction="column" gap="xs">
          <GoabSpacer vSpacing="l" />
          <GoabFormItem label="I have returned to my home community.">
            <GoabRadioGroup
              name="returnedToHome"
              onChange={({name, value}) => {
                handleChange(name, value);
                // Needed for radio buttons
                setTimeout(() => form.validateForm());
              }}
              orientation="horizontal"
              value={fieldValues.returnedToHome}
            >
              <GoabRadioItem value="Y" label="Yes" />
              <GoabRadioItem value="N" label="No" />
            </GoabRadioGroup>
          </GoabFormItem>

          {fieldValues.returnedToHome === "N" && (
            <>
              <GoabFormItem mt="m" error={fieldErrors.usePersonalNumber}>
                <GoabCheckbox
                  name="usePersonalNumber"
                  text="Use my phone number from primary contact information"
                  onChange={({name, value}) => {
                    handleChange(name!, value);
                    // Needed for checkboxes
                    setTimeout(() => form.validateForm());
                  }}
                  checked={fieldValues.usePersonalNumber}
                  error={!!personalNumberError}
                />
              </GoabFormItem>
              <GoabFormItem
                label="Phone number"
                error={fieldErrors.tempPhoneNumber}
                helpText={
                  fieldValues.usePersonalNumber
                    ? ""
                    : "This is a canadian phone number. Such as (123) 456-7890."
                }
              >
                <GoabInput
                  key={`tempPhoneNumber-${inputKey}`}
                  name="tempPhoneNumber"
                  type="text"
                  value={
                    fieldValues.usePersonalNumber
                      ? form.values.PersonalInformation.mobile ||
                        form.values.PersonalInformation.phone
                      : fieldValues.tempPhoneNumber
                  }
                  onChange={({name, value}) => {
                    if (!fieldValues.usePersonalNumber) {
                      const number = formatPhoneNumber(value);
                      // Only increment key if formatting changed the value
                      if (number !== value && number.length >= 10) {
                        setInputKey((inputKey) => inputKey + 1);
                        setTimeout(() => form.validateForm());
                      }
                      handleChange(name, number);
                    } else {
                      const number =
                        form.values.PersonalInformation.mobile ||
                        form.values.PersonalInformation.phone;
                      handleChange(name, number);
                    }
                  }}
                  onBlur={({name, value}) => handleBlur(name)}
                  error={!!tempPhoneNumberError}
                  disabled={fieldValues.usePersonalNumber}
                />
              </GoabFormItem>
            </>
          )}
        </GoabBlock>
      </GoabContainer>
      <GoabSpacer vSpacing="2xs" />
    </>
  );
};
